import { render, staticRenderFns } from "./PaymentsLoader.vue?vue&type=template&id=df5255ae&scoped=true"
import script from "./PaymentsLoader.vue?vue&type=script&lang=js"
export * from "./PaymentsLoader.vue?vue&type=script&lang=js"
import style0 from "./PaymentsLoader.vue?vue&type=style&index=0&id=df5255ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5255ae",
  null
  
)

export default component.exports